export const USER_TYPES = {
  'BDC Agent': 1,
  'Salesperson': 2,
  'Finance Manager': 3,
  'Manager': 4
}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/user.types.js